<script>
export default {
    props: {
        productCategories: {
            type: Object,
            required: true
        },
        currency: {
            type: String,
            required: true
        },
        modelValue: {
            type: Array
        },
        transferType: {
            type: String
        },
        tripType: {
            type: String
        }
    },
    /*
    data() {
        return {
            // picker: null
        }
    },
    */
    emits: [
        'update:modelValue'
    ],
    methods: {

        categoryVisible(category) {
            if (this.transferType == 'CA' && this.tripType == 'oneWay') {
                if (category.name == 'Budapest Kártya' || category.name == 'Hop On Hop Off') {
                    return false;
                }
            }
            return true;
        },

        getCurrencyPrice(priceHuf, priceEur) {
            return new Intl.NumberFormat().format(this.currency == 'HUF' ? priceHuf : priceEur) + ' ' + this.currency;
        },

        getAmount(productId) {
            // return this.orderData.extraProducts[productId]?.quantity || 0;

            let result = 0;
            this.modelValue.forEach(function (product, i) {
                if (product.id == productId) {
                    result = product.quantity;
                }
            });

            return result;
        },

        increaseAmount(productId) {

            let found = false;
            this.modelValue.forEach(function (product, i) {
                if (product.id == productId) {
                    product.quantity += 1;
                    found = true;
                }
            });

            if (!found) {
                this.modelValue.push({
                    id: productId,
                    quantity: 1
                });
            }

        },

        decreaseAmount(productId) {

            const that = this;

            this.modelValue.forEach(function (product, i) {
                if (product.id == productId) {
                    product.quantity -= 1;
                    if (product.quantity <= 0) {
                        that.modelValue.splice(i, 1);
                        return;
                    }
                }
            });
        },

    },
    mounted() {
        // ...
    }
}
</script>

<template>
    <template v-for="category in productCategories">
        <div class="row" v-if="categoryVisible(category)">
            <div class="col-12">
                <h3 class="h6 fw-bold">{{ $t(category.name) }}</h3>
                <p v-if="category.description" class="text-justify truncate-text" id="extra-bpcard">
                    <i class="fas fa-info-circle me-1"></i> {{ $t(category.description) }}
                </p>
            </div>
            <div class="col-lg-4" v-for="product in category.products">
                <div class="booking-card">
                    <div>
                        <picture>
                            <source :srcset="product.imageWebp" type="image/webp">
                            <source :srcset="product.image" type="image/png">
                            <img :src="product.image" width="250" height="119" :alt="$t(product.name)" class="img-fluid booking-card-image" loading="lazy">
                        </picture>
                    </div>
                    <div>
                        <div class="booking-card-title">{{ $t(product.name) }}
                        </div>
                        <div class="booking-card-body">
                            {{ getCurrencyPrice(product.price.HUF, product.price.EUR) }} / {{ $t('fő') }}
                        </div>
                    </div>
                    <div>
                        <div class="input-number-group">
                            <div><button type="button" class="input-number-action input-number-action-decrease" @click="decreaseAmount(product.id)">-</button>
                            </div>
                            <div class="input-number-value" :class="{ 'input-number-value-set': getAmount(product.id) > 0 }">{{
                                getAmount(product.id) }} db</div>
                            <div><button type="button" class="input-number-action input-number-action-increase" @click="increaseAmount(product.id)">+</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
</template>
